module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8hW81i/tc-custom/9781504094344.jpg?1737195128120",
      "alt": "This image is the cover for the book Lunch with the Deadly Dozen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Lunch with the Deadly Dozen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This group likes to stay active in retirement—by catching killers . . .")]), _c('br'), _c('br'), _vm._v(" Widowed and in his sixties, Thomas Quinn has been asked to lunch by Lexington Smith, the leader of a covert team who call themselves The Twelve. When Quinn accepts the invitation to join the group, he finds himself united with other retired experts—from a surgeon to a locksmith to a cabbie—in a quest to capture a killer targeting homeless victims on London’s transit system."), _c('br'), _c('br'), _vm._v(" As the body count rises, Quinn and his companions try to puzzle out a pattern. But can they protect this vulnerable population by identifying a predator amid the crowds of the London Underground?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Peter Berry\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0